const ChequeIcon = ({ fill = "#E0E7FF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.4047 14.6667C12.0866 14.6667 15.0714 11.6819 15.0714 8.00001C15.0714 4.31811 12.0866 1.33334 8.4047 1.33334C4.72281 1.33334 1.73804 4.31811 1.73804 8.00001C1.73804 11.6819 4.72281 14.6667 8.4047 14.6667Z"
        stroke="#4B5563"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.40466 4V8L11.0713 9.33333"
        stroke="#4B5563"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ChequeIcon;
